import { render, staticRenderFns } from "./add-category-info-popup.html?vue&type=template&id=88ea25be&scoped=true&"
import script from "./add-category-info-popup.js?vue&type=script&lang=js&"
export * from "./add-category-info-popup.js?vue&type=script&lang=js&"
import style0 from "./add-category-info-popup.scss?vue&type=style&index=0&id=88ea25be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ea25be",
  null
  
)

export default component.exports